<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">{{routeName}}</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <button type="submit" class="btn btn-warning btn-fill" @click="edit()">Edit Corporation</button>
                </div>
            </div>
            <div class="table-responsive" v-if="corporation">
                <table class="table table-bordered table-light">
                    <tr>
                        <th>Id</th>
                        <td>{{corporation.corporationId}}</td>
                    </tr>
                    <tr>
                        <th>name</th>
                        <td>{{corporation.name}}</td>
                    </tr>
                  <tr>
                    <th class="align-content-center">image</th>
                    <td><img :src="corporation.smallImage" alt="corporation-image" class="detail-thumbnail"></td>
                  </tr>
                    <tr>
                        <th>description</th>
                        <td>{{corporation.description}}</td>
                    </tr>
                    <tr>
                        <th>account limit</th>
                        <td>{{corporation.accountLimit}}</td>
                    </tr>
                    <tr>
                        <th>domain</th>
                        <td>{{corporation.domain}}</td>
                    </tr>

                    <tr>
                        <th>contact address</th>
                        <td>{{corporation.contactAddress}}</td>
                    </tr>
                    <tr>
                        <th>contact city</th>
                        <td>{{corporation.contactCity}}</td>
                    </tr>
                    <tr>
                        <th>contact email</th>
                        <td>{{corporation.contactEmail}}</td>
                    </tr>
                    <tr>
                        <th>contact first name</th>
                        <td>{{corporation.contactFirstName}}</td>
                    </tr>
                    <tr>
                        <th>contact last name</th>
                        <td>{{corporation.contactLastName}}</td>
                    </tr>
                    <tr>
                        <th>contact phone</th>
                        <td>{{corporation.contactPhone}}</td>
                    </tr>
                    <tr>
                        <th>contact state</th>
                        <td>{{corporation.contactState}}</td>
                    </tr>
                    <tr>
                        <th>contact zip</th>
                        <td>{{corporation.contactZip}}</td>
                    </tr>
                    <tr>
                        <th>welcome message</th>
                        <td>{{corporation.welcomeMessage}}</td>
                    </tr>
                  <tr>
                    <th>Gift Redeem Package Description</th>
                    <td>{{corporation.signupGiftDesc}}</td>
                  </tr>
                  <tr>
                    <th>Stop sending Freemium, Teaser and Takeaway emails</th>
                    <td>{{corporation.filterEmails === 1 ? 'Yes' : 'No'}}</td>
                  </tr>
                   <tr>
                     <th>Enable Community Page</th>
                     <td><span v-if="corporation.enableCorporatePage" class="badge badge-success">Yes</span><span v-else class="badge badge-danger">No</span></td>
                   </tr>
                  <tr>
                    <th>Enable Spotlight Section</th>
                    <td><span v-if="corporation.showSpotlightSection" class="badge badge-success">Yes</span><span v-else class="badge badge-danger">No</span></td>
                  </tr>
                  <tr>
                    <th>Enable Pinned Messages Section</th>
                    <td><span v-if="corporation.showPinnedMessages" class="badge badge-success">Yes</span><span v-else class="badge badge-danger">No</span></td>
                  </tr>
                  <tr>
                    <th>Corporate Page Welcome Message</th>
                    <td>{{corporation.pageWelcomeMessage}}</td>
                  </tr>
                  <tr>
                    <th>Page Administrator</th>
                    <td>{{corporation.pageAdmin ? corporation.pageAdmin : 'N/A'}}</td>
                  </tr>
                  <tr>
                    <th>Community Page Default Tab</th>
                    <td v-if="corporation.defaultCorpTab === 1">Career Coaching</td>
                    <td v-if="corporation.defaultCorpTab === 2">Community</td>
                    <td v-if="corporation.defaultCorpTab === 3">Playlists</td>
                    <td v-if="corporation.defaultCorpTab === 4">Videos</td>
                  </tr>
                    <tr>
                      <th  class="align-content-center">Spotlight Picture</th>
                      <td><img :src="corporation.spotlightPic" alt="corporation-image" class="detail-thumbnail"></td>
                    </tr>
                  <tr>
                    <th>Spotlight Quote</th>
                    <td>{{corporation.spotlightQuote}}</td>
                  </tr>
                  <tr>
                    <th>Spotlight Para1</th>
                    <td>{{corporation.spotlightPara1}}</td>
                  </tr>
                  <tr>
                    <th>Spotlight Para2</th>
                    <td>{{corporation.spotlightPara2}}</td>
                  </tr>
                  <tr>
                    <th>Spotlight Para3</th>
                    <td>{{corporation.spotlightPara3}}</td>
                  </tr>
                  <tr>
                    <th>Private Event Section Heading</th>
                    <td>{{corporation.privateEventHeading}}</td>
                  </tr>
                  <tr>
                    <th>TONE Event Section Heading</th>
                    <td>{{corporation.toneEventHeading}}</td>
                  </tr>
                  <tr>
                    <th>Archived Events Section Heading</th>
                    <td>{{corporation.archiveEventHeading}}</td>
                  </tr>
                  <tr>
                    <th>Playlist Section Heading</th>
                    <td>{{corporation.playlistHeading}}</td>
                  </tr>
                  <tr>
                    <th>Pinned Messages Section Heading</th>
                    <td>{{corporation.pinnedMessageHeading}}</td>
                  </tr>
                  <tr>
                    <th>Show Shoe Motif</th>
                    <td v-if="corporation.showShoeMotif === 1">Yes</td>
                    <td v-if="corporation.showShoeMotif !== 1">Hidden</td>
                  </tr>
                  <tr>
                    <th>Private Videos Section Heading</th>
                    <td>{{corporation.videoTabHeading}}</td>
                  </tr>
                  <tr>
                    <th>Mobile Field Visibility</th>
                    <td v-if="corporation.phoneFlag === 1">Show on Profile & Signup</td>
                    <td v-if="corporation.phoneFlag === 2">Show on Profile</td>
                    <td v-if="corporation.phoneFlag === 3">Show on Signup</td>
                    <td v-if="corporation.phoneFlag === 4">Hide on Profile & Signup</td>
                  </tr>
                  <tr>
                    <th>DOB Field Visibility</th>
                    <td v-if="corporation.dobFlag === 1">Show on Profile</td>
                    <td v-if="corporation.dobFlag === 2">Hide on Profile</td>
                  </tr>
                  <tr>
                    <th>Videos (To Show)</th>
                    <td>{{corporation.csvShowVideoCodes}}</td>
                  </tr>
                  <tr>
                    <th>Videos (To Hide)</th>
                    <td>{{corporation.csvHiddenVideoCodes}}</td>
                  </tr>
                  <tr>
                    <th>Suggested Videos for New Users (Profile/Progress)</th>
                    <td>{{corporation.profileCsvVideos}}</td>
                  </tr>
                  <tr>
                    <th>Custom Banner Settings</th>
                    <td v-if="corporation.giftIconState === 1">Gift of TONE Visible</td>
                    <td v-if="corporation.giftIconState === 2">Gift of TONE Invisible Without Custom Message'</td>
                    <td v-if="corporation.giftIconState === 3">Gift of TONE Invisible With Custom Message</td>
                  </tr>
                  <tr>
                    <th>Custom Banner Message</th>
                    <td>{{corporation.giftIconMessage}}</td>
                  </tr>
                  <tr>
                    <th>Custom Banner URL</th>
                    <td>{{corporation.giftIconUrl}}</td>
                  </tr>
                  <tr>
                    <th>Event Banner Settings</th>
                    <td v-if="corporation.bnrLinkState === 1">Link to Public Event</td>
                    <td v-if="corporation.bnrLinkState === 2">Link to Private Event</td>
                    <td v-if="corporation.bnrLinkState === 3">Custom Link</td>
                  </tr>
                  <tr>
                    <th>Event Banner (Start Date/Time)</th>
                    <td>{{corporation.bnrPvtStartTimeFmt}}</td>
                  </tr>
                  <tr>
                    <th>Event Banner (End Date/Time)</th>
                    <td>{{corporation.bnrPvtEndTimeFmt}}</td>
                  </tr>
                  <tr>
                    <th>Custom Event Banner Message</th>
                    <td>{{corporation.bnrCustomMsg}}</td>
                  </tr>
                  <tr>
                    <th>Custom Event Banner URL</th>
                    <td>{{corporation.bnrCustomMsgUrl}}</td>
                  </tr>
                  <tr>
                    <th>Send Email on Enabling Community Page</th>
                    <td v-if="corporation.cceSendEmail === 1">Yes</td>
                    <td v-if="corporation.cceSendEmail === 0">No</td>
                    <td v-if="corporation.cceSendEmail === 2">Yes (One time Email Sent)</td>
                  </tr>
                  <tr>
                    <th>Allow Live Event Section</th>
                    <td v-if="corporation.cceLiveEventParaAccess === 1">Yes</td>
                    <td v-if="corporation.cceLiveEventParaAccess === 0">No</td>
                  </tr>
                  <tr>
                    <th>Allow Custom Content Section</th>
                    <td v-if="corporation.cceCustomContentAccess === 1">Yes</td>
                    <td v-if="corporation.cceCustomContentAccess === 0">No</td>
                  </tr>
                  <tr>
                    <th>Allow Coaching Section</th>
                    <td v-if="corporation.cceCommCoachingAccess === 1">Yes</td>
                    <td v-if="corporation.cceCommCoachingAccess === 0">No</td>
                  </tr>
                  <tr>
                    <th>Allow Video Share Section</th>
                    <td v-if="corporation.cceShareVideoAccess === 1">Yes</td>
                    <td v-if="corporation.cceShareVideoAccess === 0">No</td>
                  </tr>
                  <tr>
                    <th>Override Package Settings</th>
                    <td v-if="corporation.useTrialEndDateCustom === 1">Yes</td>
                    <td v-if="corporation.useTrialEndDateCustom === 0">No</td>
                  </tr>
                  <tr v-if="corporation.useTrialEndDateCustom === 1">
                    <th>Trial Expiry Date</th>
                    <td>{{corporation.trialEndDateCustom}}</td>
                  </tr>
                  <tr>
                    <th>Video Share Permission (Corp)</th>
                    <td v-if="corporation.corpSharingPermissions.shareVideoPermission === 1">Allow All Users Full Access</td>
                    <td v-if="corporation.corpSharingPermissions.shareVideoPermission === 4">Allow Full Access to Selected Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareVideoPermission === 2">All User share with Community with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareVideoPermission === 3">All User share with Individual with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareVideoPermission === 5">All User share with Friends with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareVideoPermission === 0">Do Not Allow Share</td>
                  </tr>
                  <tr v-if="corporation.corpSharingPermissions.shareVideoPermission > 1">
                    <th>Video Share Permission (User List)</th>
                    <td>{{corporation.corpSharingPermissions.shrVidPermUserIdCsv}}</td>
                  </tr>
                  <tr>
                    <th>Corporate Playlist Share Permission (Playlist Page)</th>
                    <td v-if="corporation.corpSharingPermissions.corpPlaylistShareOptnPermission === 1">Allow All Users Full Access</td>
                    <td v-if="corporation.corpSharingPermissions.corpPlaylistShareOptnPermission === 4">Allow Full Access to Selected Users</td>
                    <td v-if="corporation.corpSharingPermissions.corpPlaylistShareOptnPermission === 2">All User share with Community with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.corpPlaylistShareOptnPermission === 3">All User share with Individual with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.corpPlaylistShareOptnPermission === 5">All User share with Friends with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.corpPlaylistShareOptnPermission === 0">Do Not Allow Share</td>
                  </tr>
                  <tr v-if="corporation.corpSharingPermissions.corpPlaylistShareOptnPermission > 1">
                    <th>Corporate Playlist Share Permission (Playlist - User List)</th>
                    <td>{{corporation.corpSharingPermissions.corpPlaylistShrareOptnCsv}}</td>
                  </tr>
                  <tr>
                    <th>Corporate Playlist Share Permission</th>
                    <td v-if="corporation.corpSharingPermissions.shareCompanyPlaylistPermission === 1">Allow All Users Full Access</td>
                    <td v-if="corporation.corpSharingPermissions.shareCompanyPlaylistPermission === 4">Allow Full Access to Selected Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareCompanyPlaylistPermission === 2">All User share with Community with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareCompanyPlaylistPermission === 3">All User share with Individual with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareCompanyPlaylistPermission === 5">All User share with Friends with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareCompanyPlaylistPermission === 0">Do Not Allow Share</td>
                  </tr>
                  <tr v-if="corporation.corpSharingPermissions.shareCompanyPlaylistPermission > 1">
                    <th>Corporate Playlist Share Permission (User List)</th>
                    <td>{{corporation.corpSharingPermissions.shrCompPlistPermUserIdCsv}}</td>
                  </tr>
                  <tr>
                    <th>Personal Playlist Share Permission</th>
                    <td v-if="corporation.corpSharingPermissions.sharePersonalPlaylistPermission === 1">Allow All Users Full Access</td>
                    <td v-if="corporation.corpSharingPermissions.sharePersonalPlaylistPermission === 4">Allow Full Access to Selected Users</td>
                    <td v-if="corporation.corpSharingPermissions.sharePersonalPlaylistPermission === 2">All User share with Community with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.sharePersonalPlaylistPermission === 3">All User share with Individual with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.sharePersonalPlaylistPermission === 5">All User share with Friends with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.sharePersonalPlaylistPermission === 0">Do Not Allow Share</td>
                  </tr>
                  <tr v-if="corporation.corpSharingPermissions.sharePersonalPlaylistPermission > 1">
                    <th>Personal Playlist Share Permission (User List)</th>
                    <td>{{corporation.corpSharingPermissions.shrPerPlistPermUserIdCsv}}</td>
                  </tr>
                  <tr>
                    <th>Trending Playlist Share Permission</th>
                    <td v-if="corporation.corpSharingPermissions.shareTrendingPlaylistPermission === 1">Allow All Users Full Access</td>
                    <td v-if="corporation.corpSharingPermissions.shareTrendingPlaylistPermission === 4">Allow Full Access to Selected Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareTrendingPlaylistPermission === 2">All User share with Community with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareTrendingPlaylistPermission === 3">All User share with Individual with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareTrendingPlaylistPermission === 5">All User share with Friends with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareTrendingPlaylistPermission === 0">Do Not Allow Share</td>
                  </tr>
                  <tr v-if="corporation.corpSharingPermissions.shareTrendingPlaylistPermission > 1">
                    <th>Trending Playlist Share Permission (User List)</th>
                    <td>{{corporation.corpSharingPermissions.shrTrndPlistPermUserIdCsv}}</td>
                  </tr>
                  <tr>
                    <th>Archive Playlist Share Permissions(Events Page)</th>
                    <td v-if="corporation.corpSharingPermissions.shareEventCoachingTipPermission === 1">Allow All Users Full Access</td>
                    <td v-if="corporation.corpSharingPermissions.shareEventCoachingTipPermission === 4">Allow Full Access to Selected Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareEventCoachingTipPermission === 2">All User share with Community with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareEventCoachingTipPermission === 3">All User share with Individual with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareEventCoachingTipPermission === 5">All User share with Friends with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareEventCoachingTipPermission === 0">Do Not Allow Share</td>
                  </tr>
                  <tr v-if="corporation.corpSharingPermissions.shareEventCoachingTipPermission > 1">
                    <th>Archive Playlist Share Permissions on Events Page (User List)</th>
                    <td>{{corporation.corpSharingPermissions.shrEventCoachPlistPermUserIdCsv}}</td>
                  </tr>
                  <tr>
                    <th>Archive Playlist Share Permissions(Experts Page)</th>
                    <td v-if="corporation.corpSharingPermissions.shareExpertCoachingTipPermission === 1">Allow All Users Full Access</td>
                    <td v-if="corporation.corpSharingPermissions.shareExpertCoachingTipPermission === 4">Allow Full Access to Selected Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareExpertCoachingTipPermission === 2">All User share with Community with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareExpertCoachingTipPermission === 3">All User share with Individual with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareExpertCoachingTipPermission === 5">All User share with Friends with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareExpertCoachingTipPermission === 0">Do Not Allow Share</td>
                  </tr>
                  <tr v-if="corporation.corpSharingPermissions.shareExpertCoachingTipPermission > 1">
                    <th>Archive Playlist Share Permissions on Experts Page (User List)</th>
                    <td>{{corporation.corpSharingPermissions.shrExpertCoachPlistPermUserIdCsv}}</td>
                  </tr>
                  <tr>
                    <th>Archive Playlist Share Permissions(Archive Playlist Page)</th>
                    <td v-if="corporation.corpSharingPermissions.shareArchivePlistPermission === 1">Allow All Users Full Access</td>
                    <td v-if="corporation.corpSharingPermissions.shareArchivePlistPermission === 4">Allow Full Access to Selected Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareArchivePlistPermission === 2">All User share with Community with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareArchivePlistPermission === 3">All User share with Individual with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareArchivePlistPermission === 5">All User share with Friends with List of Users</td>
                    <td v-if="corporation.corpSharingPermissions.shareArchivePlistPermission === 0">Do Not Allow Share</td>
                  </tr>
                  <tr v-if="corporation.corpSharingPermissions.shareArchivePlistPermission > 1">
                    <th>Archive Playlist Share Permissions on Archive Playlist Page (User List)</th>
                    <td>{{corporation.corpSharingPermissions.shrArchivePlistPermUserIdCsv}}</td>
                  </tr>
                    <tr>
                        <th>status</th>
                        <td>
                            <span class="badge badge-success" v-if="corporation.active"> Active </span>
                            <span class="badge badge-danger" v-else> Inactive </span>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'CorporationDetails',
        components: {
            LTable,
        },
        created (){
        this.$store.dispatch('GET_SELECTED_CORPORATION', this.$route.params.id)
    },
    data () {
        return { }
    },
    methods: {
        edit(){
            this.$router.push({ name: 'Edit Corporation', params: { id: this.corporation.corporationId}})
        },
        capitalizeFirstLetter (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        }
    },
    computed: {
        ...mapGetters([ 'selectedCorporation']),
        routeName () {
            const {name} = this.$route;
            return this.capitalizeFirstLetter(name);
        },
        corporation(){
            return this.selectedCorporation
        }

    }
    }
</script>

<style>
    th{
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Corporations/CorporationDetails.vue